// extracted by mini-css-extract-plugin
export default {"container":"style_container__lSNzv","privacy":"style_privacy__Y5Csa"};